//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import PropTypes           from '@/components/PropTypes';
import MembershipOptions   from '@/components/connected/MembershipOptions';
import appStyles           from '@/styles.module.scss';
import { MembershipActions } from '@/store/actions/membership';
import { CompanyActions }    from '@/store/actions/company';
import { UserActions }       from '@/store/actions/user';
import React               from 'react';
import { compose }         from 'redux';
import { connect }         from 'react-redux';
import { bindActionCreators } from 'redux';
import _                   from 'lodash';

import ComponentHelper from '@/helper/ComponentHelper';

import styles from './styles.module.scss';

class Screen extends React.Component {
    componentDidMount() {
        const { isLoggedIn, userCompanyId } = this.props;

        this.props.fetchMemberships();

        if (isLoggedIn) {
            this.props.fetchUser();

            if (userCompanyId) {
                this.props.fetchCompany({ id: userCompanyId });
            }
        }
    }

    render() {
        const { history } = this.props;

        return (
            <div className={appStyles.defaultContainer}>
                <div className={appStyles.defaultInnerContainer}>
                    <div className={styles.membershipContainer}>
                        <MembershipOptions
                            history={history}
                        />
                    </div>
                </div>
            </div>
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }
}

Screen.propTypes = {
    history:        PropTypes.object,
    isLoggedIn:     PropTypes.bool,
    userCompanyId:  PropTypes.string,
    fetchMemberships: PropTypes.func,
    fetchUser:      PropTypes.func,
    fetchCompany:   PropTypes.func,
};

Screen.defaultProps = {
    history:          null,
    isLoggedIn:       false,
    userCompanyId:    null,
    fetchMemberships: _.noop,
    fetchUser:        _.noop,
    fetchCompany:     _.noop,
};

Screen.renderAffectingProps = Object.keys(Screen.defaultProps);

Screen.renderAffectingStates = [];

const mapStateToProps = (state) => {
    const isLoggedIn     = !_.isEmpty(_.get(state, 'user.token', null));
    const userCompanyId  = _.get(state, 'user.company');

    return {
        isLoggedIn,
        userCompanyId,
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchMemberships: MembershipActions.fetchMemberships,
        fetchUser:        UserActions.fetch,
        fetchCompany:     CompanyActions.fetchCompany,
    },
    dispatch,
);

export default compose(connect(
    mapStateToProps,
    mapDispatchToProps,
))(Screen);
